<template>
  <v-dialog v-if="dialogItem" v-model="productDialogToggle" :width="$vuetify.breakpoint.mdAndUp? '70%':'100%'">
    <v-card class="py-4">
    <div class="d-flex justify-end">
      <v-btn @click="productDialogToggle = false"  color="white" x-small depressed fab>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
      <v-row class="ma-0" style="width:100%">
        <v-col cols="12" md="6">
          <v-img
            class="mx-4 cursor-pointer"
            :src="dialogItem.images[selectedImage]"
            :aspect-ratio="1/1"
          ></v-img>
          <v-slide-group
            v-model="selectedImage"
            class="pa-4"
            active-class="success"
            show-arrows
            mandatory
          >
            <v-slide-item
              v-for="image in dialogItem.images"
              :key="image.id"
              v-slot="{ toggle, active }"
            >
              <v-card width="80" height="80" class="mr-2">
                <v-img
                  @click="toggle"
                  :src="image.src"
                  aspect-ratio="1"
                  :gradient="
                    active
                      ? '90deg, rgba(237,237,237,0.2945553221288515) 0%, rgba(237,237,237,0.29) 100%'
                      : ''
                  "
                ></v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>

        <v-col cols="12" md="6">
          <v-card-title class="pb-0 px-0 text-h3">{{ dialogItem.title }}</v-card-title>
          <v-card-title class="pt-0 px-0 primary--text">
            RM {{ price }}
          </v-card-title>
          <v-card-text class="grey--text darken-4 px-0" v-html="dialogItem.body_html"> </v-card-text>

          <div v-if="boxContentType != 'boxType'">
            <!-- need to handle multiple variant -->
            <template v-if="dialogItem.variants.length > 1">
              <label class="d-block">{{dialogItem.options[0].name}}</label>
              <v-btn-toggle @change="updateVariation" class="flex-wrap" mandatory v-model="productVariant">
                <v-btn 
                :disabled="(!isFlower && dialogItem.variants[index].inventory_quantity <= 0) || !dialogItem.variants[index].is_available" 
                small 
                v-for="(option, index) in optionsValue" 
                :key="option" 
                class="variant-btn mt-2 ml-1">
                  {{option}}
                </v-btn>
              </v-btn-toggle>
            </template>

            <label v-if="boxContentType != 'boxAddons' || (boxContentType == 'boxAddons' && !isFlower)" class="d-block mt-3">Quantity</label>
            <div v-if="boxContentType != 'boxAddons' || (boxContentType == 'boxAddons' && !isFlower)" style="30%" class="counter-container">
              <div class="d-flex justify-space-around counter-wrapper align-center">
                <v-btn
                  @click="reduce"
                  class="xx-small"
                  elevation="0"
                  color="primary"
                  fab
                  x-small
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <input v-model="amount" type="text" readonly />
                <v-btn
                  @click="increase"
                  class="xx-small"
                  elevation="0"
                  color="primary"
                  fab
                  x-small
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
          </div>


          <v-card-actions
            v-if="boxContentType != 'boxType'"
            class="pb-5 mt-6 justify-center"
          >
            <v-btn color="primary" @click="productDialogToggle = false" style="width:100%" class="add-to-box-btn">
              <span>ADD TO BOX</span>
            </v-btn>
          </v-card-actions>
          <div class="px-5" v-else>
            <b>CHOOSE VARIANT</b>
            <div
              style="
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 12px;
              "
            >
              <v-card
                v-for="variant in dialogItem.variants"
                :key="variant.id"
                class="d-flex align-center"
                outlined
                @click="selectBox(variant)"
              >
                <v-avatar size="50" tile>
                  <v-img
                    :src="
                      variant.featured_image
                        ? variant.featured_image
                        : dialogItem.featured_image
                    "
                  ></v-img>
                </v-avatar>
                <div class="d-flex flex-no-wrap justify-space-between">
                  <v-card-subtitle> {{ variant.option1 }} </v-card-subtitle>
                </div>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { ACTION_MODIFY_BOX } from "../../store/actions";
import { TYPE_SET_PRODUCT_DIALOG_TOGGLE, TYPE_SET_SUBSTEP } from "../../store/mutations";
export default {
  name: "hb-bab-product-dialog",
  props: {
    boxContentType: String,
  },
  data() {
    return {
      selectedImage: "",
      productVariant: 0
    };
  },
  methods: {
    increase() {
      this.amount++;
    },
    reduce() {
      if (this.amount == 0) return;
      this.amount--;
    },
    selectBox(variant) {
      this.productDialogToggle = false;
      this.$store.dispatch(ACTION_MODIFY_BOX, {
        product: this.dialogItem,
        amount: 1,
        boxContentType: "boxType",
        variant
      });
      this.substep = 2;
    },
    updateVariation(e){
      if(!e || e >= this.dialogItem.variants.length) return;
      this.amount = Number(this.amount);
    }
  },
  computed: {
    productDialogToggle: {
      get() {
        return this.$store.state.productDialogToggle;
      },
      set(value) {
        this.$store.commit(TYPE_SET_PRODUCT_DIALOG_TOGGLE, value);
      },
    },
    amount: {
      get() {
        const box = this.$store.state.box.find(
          (boxItem) => boxItem.id == this.dialogItem.id
        );
        return box ? box.amount : 0;
      },
      set(amount) {
        this.$store.dispatch(ACTION_MODIFY_BOX, {
          product: this.dialogItem,
          amount,
          boxContentType: this.boxContentType,
          variant: this.dialogItem.variants[this.productVariant]
        });
      },
    },
    dialogItem() {
      return this.$store.state.productDialogItem;
    },
    hasVariants(){
      return this.dialogItem.variants.length > 1;
    },
    substep:{
      get(){
        return this.$store.state.substep;
      },
      set(value){
        this.$store.commit(TYPE_SET_SUBSTEP, value)
      }
    },
    optionsValue(){
      return this.dialogItem.variants.map(variant => variant.title);
    },
    price(){
      if(this.productVariant === undefined || this.productVariant >= this.dialogItem.variants.length) return 0;
      return this.dialogItem.variants[this.productVariant].price
    },
    isFlower(){
      return this.dialogItem.tags.includes('flowers');
    }
  },
};
</script>

<style scoped>
.add-to-box-btn {
  background: white;
  text-transform: uppercase;
  padding: 0.3rem 0;
  border: 1px solid #eaecf4;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
  border-radius: 5rem;
  font-size: 0.8rem;
  font-weight: 400;
  color: #666;
  width: 7rem;
  text-align: center;
  line-height: 2.1;
}

input {
  border: none;
  width: 2rem;
  padding: 0;
  text-align: center;
  font-weight: 500;
  font-size: 1.2rem !important;
  color: black !important;
  line-height: 1 !important;
}

button.xx-small {
  height: 25px !important;
  width: 25px !important;
}

.counter-container{
  background: white;
  text-transform: uppercase;
  padding: 0.3rem 0;
  border: 1px solid #eaecf4;
  box-sizing: border-box;
  border-radius: 5rem;
  font-size: 0.8rem;
  font-weight: 400;
  color: #666;
  width: 7rem;
  text-align: center;
  line-height: 2.1;
}

.variant-btn{
  border: 1px solid #EAECF4;
  box-sizing: border-box;
  border-radius: 24px !important;
  background: white !important;
}

.variant-btn.v-item--active{
  background: #CB555B !important;
  color:white;
}

.variant-btn.v-item--active::before{
  opacity: 0 !important;
}

</style>